// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + "3ef98f8968d00cc5c322" + ".css";
};